import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import axios from "../../axios-vmou";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import styles from "./copy.module.css";
import Navbar from "../main/navbar";
import logo from "../../assets/vmou.png";
import { Sidebar } from 'primereact/sidebar';
import * as actions from '../../store/actions/index'
import { useHistory } from "react-router-dom";

const Invalidcopies = (props) => {
  const [visibleRight, setVisibleRight] = useState(false);
  const onSignout = () => {
    props.onlogout();
  }
  let emptycopy = {
    copyno:'',
    controlno: "",
    marks: ""
  };

  const [copy, setcopy] = useState(emptycopy);
  const [copies, setCopies] = useState([]);
  const [selectedcopies, setSelectedcopies] = useState(null);
  const [copyDialog, setcopyDialog] = useState(false);
  const [deletecopyDialog, setDeletecopyDialog] = useState(false);

  const [mode, setMode] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const history = useHistory();

  useEffect(() => {
    if (history.location.state.batch.invalid) setCopies(history.location.state.batch.invalid);
  }, [history.location.state.batch.invalid]); 

  const openNew = () => {
    setcopy(emptycopy);
    setSubmitted(false);
    setMode("New");
    setcopyDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setcopyDialog(false);
  };

  const hideDeletecopyDialog = () => {
    setDeletecopyDialog(false);
  };

  const savecopy = () => {
    setSubmitted(true);
    let authOptions="";
    if (copy.copyno.trim()) {
      // let _copies = [...copies];
      let _copy = { ...copy };
      const j = history.location.state.batch.marks.find(x => x.controlno === _copy.controlno );
      if (j) {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: "Scholar No Exists for Marks Entry...NOT INVALID",
        });
        return;
      }
      if (mode === "Edit") {
        const index = findIndexById(_copy.copyno);
        if (index >=0) {
          authOptions = {
            method: "PUT",
            url: "/batch/invalid/"+history.location.state.batch._id,
            data: _copy,
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
          };
        } else {
          authOptions = {
            method: "POST",
            url: "/batch/invalid/"+history.location.state.batch._id,
            data: _copy,
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
          };
        }
        axios(authOptions)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Invalid copy Edited",
              life: 3000,
            });
            setCopies(response.data);
            setcopyDialog(false);
            setcopy(emptycopy);
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data,
            });
          });
      } else {
        const i = copies.find(x => x.copyno === _copy.copyno );
        if (i) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "This Copy Number Already Entered",
          });
          return;
        }
        let authOptions = {
          method: "POST",
          url: "/batch/invalid/"+history.location.state.batch._id,
          data: _copy,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        };
        axios(authOptions)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "copy Created",
              life: 3000,
            });
            setCopies(response.data);
            setcopyDialog(false);
            setcopy(emptycopy);
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data,
            });
          });
      }
    }
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < copies.length; i++) {
      if (copies[i].copyno=== id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const editcopy = (copy) => {
    setcopy({ ...copy });
    setMode("Edit");
    setcopyDialog(true);
  };

  const confirmDeletecopy = (copy) => {
    setcopy(copy);
    setDeletecopyDialog(true);
  };

  const deletecopy = () => {
    let authOptions = {
      method: "put",
      url: "/batch/deleteinvalid/"+history.location.state.batch._id,
      data: copy,
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
        let _copies = copies.filter(val => val.copyno !== copy.copyno);
        setCopies(_copies);
        setDeletecopyDialog(false);
        setcopy(emptycopy);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Invalid copy Entry Deleted",
          life: 3000,
        });
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
      });
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _copy = { ...copy };
    _copy[`${name}`] = val;
    setcopy(_copy);
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button-success p-mr-2"
          onClick={openNew}
        />
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
      </React.Fragment>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text p-button-success p-mr-2"
          onClick={() => editcopy(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-text p-button-warning"
          onClick={() => confirmDeletecopy(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className={styles.tableheader}>
      <h4 className="mx-0 my-1">Manage Invalid Copies</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
    </div>
  );
  const copyDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        className="p-button-text"
        onClick={savecopy}
      />
    </React.Fragment>
  );
  const deletecopyDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeletecopyDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deletecopy}
      />
    </React.Fragment>
  );


  return (
    <div className={styles.datatablecruddemo}>
      <Toast ref={toast} />
      <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>Coord ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
      <div className="Headerusr" style={{ position: "sticky" }}>
        <img
          src={logo}
          alt="VMOU"
          height={100}
          width={90}
          style={{ margin: "0px 0 0 20px" }}
        ></img>
        <h2 style={{ marginTop: "0", textAlign: "center" }}>
          Examiner Module
          <br />
          {'Invalid Copies for Batch : '+history.location.state.batch.batchcode}
        </h2>
        <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
          <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
          <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
        </div>
      </div>
      <Navbar />
      <div style={{width:'40%', margin:'auto'}} className={styles.card}>
        <Toolbar
          className="p-mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>

        <DataTable
          resizableColumns
          columnResizeMode="fit"
          showGridlines
          className="p-datatable-sm"
          ref={dt}
          value={copies}
          selection={selectedcopies}
          onSelectionChange={(e) => setSelectedcopies(e.value)}
          dataKey="copyno"
          sortField="copyno"
          sortOrder={1}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} copies"
          globalFilter={globalFilter}
          header={header}
          responsiveLayout="scroll"
        >
          <Column
            field="copyno"
            header="Copy No"
            sortable
            style={{ width: "30%" , textAlign:"center",padding:'0 1px 0 4px' }}
          ></Column>
          <Column
            field="controlno"
            header="Sch No"
            sortable
            style={{ width: "30%"  , padding:'0 1px 0 1px'}}
          ></Column>
          <Column field="marks" header="Marks" style={{ width: "25%" , padding:'0 1px 0 1px' }}></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{  padding:'0 1px 0 1px'}}
          ></Column>
        </DataTable>
        <div className='mt-2' style={{textAlign:'center'}}>            
          <Button label="Back"  className="p-button-rounded p-button-danger" onClick={()=>history.goBack()} />
        </div>
      </div>

      <Dialog
        visible={copyDialog}
        style={{ width: "450px" }}
        header="Invalid Copy Details"
        modal
        className="p-fluid"
        footer={copyDialogFooter}
        onHide={hideDialog}
      >
        <div className="p-field">
          <label >Copy No*</label>
          <InputText
            value={copy.copyno}
            onChange={(e) => onInputChange(e, "copyno")}
            required
            className={classNames({
              "p-invalid": submitted && !copy.copyno,
            })}
          />
          {submitted && !copy.copyno && (
            <small className="p-error">Copy No is required.</small>
          )}
        </div>
        <div className="p-field">
          <label >Sch No*</label>
          <InputText
            value={copy.controlno}
            onChange={(e) => onInputChange(e, "controlno")}
            required
            className={classNames({ "p-invalid": submitted && !copy.controlno })}
          />
          {submitted && !copy.controlno && (
            <small className="p-error">Schno is required.</small>
          )}
        </div>
        <div className="p-field">
          <label >Marks*</label>
          <InputText
            value={copy.marks}
            onChange={(e) => onInputChange(e, "marks")}
            required
            className={classNames({
              "p-invalid": submitted && !copy.marks,
            })}
          />
          {submitted && !copy.marks && (
            <small className="p-error">Marks is required.</small>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deletecopyDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deletecopyDialogFooter}
        onHide={hideDeletecopyDialog}
      >
        <div className={styles.confirmationcontent}>
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {copy && (
            <span>
              Are you sure you want to Delete <b>{copy.copyno}</b>?
            </span>
          )}
        </div>
      </Dialog>

    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    userid: state.auth.userid,
    email: state.auth.email,
    isAuth: state.auth.token !== null,
  };
};

const mapDispatchToProps = dispatch => {
  return {
      onlogout:() => dispatch(actions.logout())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Invalidcopies);